import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { jqxTreeComponent } from 'jqwidgets-ng/jqxtree';
import { jqxLoaderComponent } from 'jqwidgets-ng/jqxloader';
import { environment } from '../../../environments/environment';
import { MenuModel } from '../../services/sso/models/menu.model';
import { MenuService } from '../../services/menu/menu.service';
import { JqWidgets } from 'src/app/utils/jqWidgets';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CrudService } from 'src/app/services/crud/crud.service';
import { TextoModel } from 'src/app/services/sso/models/texto.model';
import { ApartadoModel } from 'src/app/services/sso/models/apartado.model';
import { jqxInputComponent } from 'jqwidgets-ng/jqxinput';
import { MainComponent } from '../main/main.component';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';

@Component({
  selector: 'app-custom-menu',
  templateUrl: './apartados.component.html',
  styleUrls: ['./apartados.component.css']
})
export class ApartadosComponent implements OnInit, AfterViewInit {
  @ViewChild('loader') loader: jqxLoaderComponent;
  @ViewChild('menu') menuMaestro: jqxTreeComponent;
  @ViewChild('gridApartados') gridApartados: jqxGridComponent;
  @ViewChild('ebSubApartado') ebSubApartado: jqxInputComponent;
  @ViewChild('ebNombre') ebNombre: jqxInputComponent;
  @ViewChild('ebAcronimo') ebAcronimo: jqxInputComponent;
  @ViewChild('ebObservaciones') ebObservaciones: jqxInputComponent;

  private componentRef = null;

  public environment = environment;

  // Variables para grid
  public dataSourceMenu: any;
  public dataAdapterMenu: any;
  public recordsMenu: any;
  public dataSourceApartados: any;
  public dataAdapterApartados: any;
  public menu: MenuModel;
  public apartados: ApartadoModel[] = [];
  public textos: TextoModel[] = [];
  public apartadoSelec: ApartadoModel;
  public opcionSelec: number = 0;
  public opcionTexto: string = "";

  // Preparo las columnas del grid
  public columnsApartados = [
    { text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'id', width: 10, hidden: true },
    { text: 'IdMenuOpcion', columntype: 'textbox', filtertype: 'textbox', datafield: 'idMenuOpcion', width: 10, hidden: true },
    { text: 'Subapartado', columntype: 'textbox', filtertype: 'textbox', datafield: 'subapartado', width: 150 },
    {
      text: 'Nombre', columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 250,
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="margin-left: 4px;">Total: ' +
            aggregates["Total"] + '</div>';
        }
        return renderstring;
      }
    },
    { text: 'Acrónimo', columntype: 'textbox', filtertype: 'textbox', datafield: 'acronimo', width: 120, },
    { text: 'Observaciones', columntype: 'textbox', filtertype: 'textbox', datafield: 'observaciones', width: 400 }
  ];

  //  Esto es para que los textos en los controles del grid salgan en español
  public langGrid = JqWidgets.getLocalization('es');

  constructor(
    private menuService: MenuService,
    private crudService: CrudService,
    private modal: NzModalService) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.getMenu();
  }

  // Este método es llamado por el creador del componente
  public init(componentRef: any) {
    this.componentRef = componentRef;
  }

  // Obtiene el menú maestro
  async getMenu() {
    try {
      this.loader.open();
      this.menu = await this.menuService.getMenu(1);
      if (this.menu) {
        this.dataSourceMenu = {
          datatype: 'json',
          datafields:
            [
              { name: 'Id', type: 'string', map: 'Id' },
              { name: 'PadreId', type: 'string', map: 'PadreId' },
              { name: 'TextoId', type: 'string', map: 'TextoId' },
              { name: 'Orden', type: 'string', map: 'Orden' },
              { name: 'AccionId', type: 'string', map: 'AccionId' }
            ],
          id: 'Id',
          localdata: this.menu.Opciones
        };
        this.dataAdapterMenu = new jqx.dataAdapter(this.dataSourceMenu, { autoBind: true });
        this.recordsMenu = this.dataAdapterMenu.getRecordsHierarchy('Id', 'PadreId', 'items',
          [
            { name: 'Id', map: 'id' },
            { name: 'TextoId', map: 'label' },
            { name: 'AccionId', map: 'value' }
          ]);
        if (!this.recordsMenu) {
          this.recordsMenu = [];
        }
        // Coloco los tooltips con el texto
        const t = setTimeout(async () => {
          clearTimeout(t);
          if (this.textos.length < 1) {
            await this.getTextos();
          }
          const items: any = this.menuMaestro.getItems();
          if (items) {
            items.forEach(element => {
              element.OpcionOriginalId = element.id;
              const ti = this.textos.find(x => x.Id === element.label);
              element.titleElement.attr('title', ti ? ti.Texto : '');
            });
          }
        }, 500);
      }
      this.loader.close();
    } catch (e) {
      console.log(e);
    }
  }

  async getTextos() {
    try {
      this.textos = await this.crudService.getTextos(1);
    } catch (e) {
      console.log(e);
    }
  }

  async onSelectMenu(event: any) {
    const args = event.args;
    const item: any = this.menuMaestro.getItem(args.element);
    // Sólo me interesan las opciones finales
    if (item && item.nextItem && item.nextItem.parentId !== item.id) {
      this.opcionSelec = item.id;
      const ti = this.textos.find(x => x.Id === item.label);
      this.opcionTexto = ti ? ti.Texto : item.label;
      if (this.gridApartados) {
        this.gridApartados.clearselection();
      }
      this.apartadoSelec = null;
      await this.getApartados(this.opcionSelec);
    } else {
      this.opcionSelec = null;
    }
  }

  onRowSelectApartados(event: any) {
    this.apartadoSelec = this.apartados[event.args.rowindex];
    const t = setTimeout(() => {
      clearTimeout(t);
      this.ebAcronimo.val(this.apartadoSelec.Acronimo);
      this.ebSubApartado.val(this.apartadoSelec.SubApartado);
      this.ebNombre.val(this.apartadoSelec.Nombre);
      this.ebObservaciones.val(this.apartadoSelec.Observaciones);
    }, 100);
  }

  getApartados(opcionId: number) {
    try {
      this.loader.open();
      this.apartados = [];
      const t = setTimeout(async () => {
        clearTimeout(t);
        this.gridApartados.beginupdate();
        this.apartados = await this.menuService.getApartados(opcionId);
        if (this.apartados) {
          this.dataSourceApartados = {
            datatype: 'json',
            datafields:
              [
                { name: 'id', type: 'string', map: 'Id' },
                { name: 'idMenuOpcion', type: 'string', map: 'IdMenuOpcion' },
                { name: 'acronimo', type: 'string', map: 'Acronimo' },
                { name: 'nombre', type: 'string', map: 'Nombre' },
                { name: 'subapartado', type: 'string', map: 'SubApartado' },
                { name: 'observaciones', type: 'string', map: 'Observaciones' }
              ],
            id: 'Id',
            localdata: this.apartados,
            sortcolumn: 'subapartado',
            sortdirection: 'asc'
          };
          this.dataAdapterApartados = new jqx.dataAdapter(
            this.dataSourceApartados,
            {
              autoBind: true
            });
        }
        this.gridApartados.endupdate();
        this.loader.close();
      }, 500);
    } catch (e) {
      console.log(e);
    }
  }

  public onNuevo() {
    if (this.opcionSelec > 0) {
      this.gridApartados.clearselection();
      this.apartadoSelec = new ApartadoModel();
      const t = setTimeout(() => {
        clearTimeout(t);
        this.ebAcronimo.val('');
        this.ebSubApartado.val('');
        this.ebNombre.val('');
        this.ebObservaciones.val('');
        this.ebNombre.focus();
      }, 500);
    } else {
      MainComponent.showError('ATENCIÓN', 'Seleccione una opción del menú', 2000);
    }
  }

  public async onGuardar() {
    if (this.opcionSelec < 1) {
      MainComponent.showError('ATENCIÓN', 'Seleccione una opción del menú', 2000);
    } else {
      this.apartadoSelec.IdMenuOpcion = this.opcionSelec;
      this.apartadoSelec.Acronimo = this.ebAcronimo.val().trim();
      this.apartadoSelec.SubApartado = this.ebSubApartado.val().trim();
      this.apartadoSelec.Nombre = this.ebNombre.val().trim();
      this.apartadoSelec.Observaciones = this.ebObservaciones.val();
      if (this.apartadoSelec && this.apartadoSelec.Acronimo && this.apartadoSelec.Acronimo.length > 0 &&
        this.apartadoSelec.Nombre && this.apartadoSelec.Nombre.length > 0) {
        if (await this.menuService.saveApartado(this.apartadoSelec)) {
          if (this.apartadoSelec.Id < 1) {
            this.apartadoSelec = null;
          }
          MainComponent.showSuccess('ATENCIÓN', 'Registro almacenado', 2000);
          this.getApartados(this.opcionSelec);
        }
      } else {
        MainComponent.showError('ATENCIÓN', 'Rellene los campos obligatorios', 2000);
      }
    }
  }

  public onBorrar() {
    if (this.apartadoSelec) {
      this.modal.confirm({
        nzTitle: '<i>ATENCION</i>',
        nzContent: 'Quiere borrar el apartado ' + this.apartadoSelec.Nombre + ' ?',
        nzCentered: true,
        nzCancelText: 'CANCELAR',
        nzOkText: 'SI',
        nzOnOk: async () => {
          if (this.menuService.deleteApartado(this.apartadoSelec.Id)) {
            this.gridApartados.clearselection();
            this.apartadoSelec = null;
            this.getApartados(this.opcionSelec);
          } else {
            MainComponent.showError('ATENCIÓN', 'Algo ha ido mal', 2000);
          }
        }
      });
    } else {
      MainComponent.showError('ATENCIÓN', 'Seleccione un apartado', 2000);
    }
  }

}

